import React, { useState } from 'react';
import { connect } from 'react-redux';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import { _ } from '../../functions/translator';
import { filterChange } from '../../actions';
import { FilterActions } from '../../constants/constants';

const TimelineSelect = (props) => {
    const [selected, setSelected] = useState('start_date');
 
    const useStyles = makeStyles((theme) => ({
        selected: {
          backgroundColor: '#3f51b5 !important',
          color: 'white',
        },
      }));
    const classes = useStyles();

    const handleChange = (event) => {
        if (event.target.value !== selected) {
            setSelected(event.target.value);
            props.filterChange(FilterActions.TIME_SELECT, event.target.value);
        }
    }

    return(
        <>
            <p className="timefilter-label ml-2 mb-1">{_('Filtrar por')}:</p>
            <Select
                className="ml-2"
                style={{width: '94%'}}
                name="input_type"
                value={selected}
                onChange={handleChange}
                MenuProps={{
                    MenuListProps: {
                        disablePadding: true,
                    },
                    classes: {
                        paper: classes.paper,
                    },
                    }}
                >
                <MenuItem value={'last_update_datetime'}>
                    <p className='m-0'>{_('Fecha de última actualización')}</p>
                </MenuItem>
                <MenuItem value={'start_date'}>
                    <p className='m-0'>{_('Fecha de Liberación')}</p>
                </MenuItem>
                <MenuItem value={'finish_date'}>
                    <p className='m-0'>{_('Fecha planificada de cierre')}</p>
                </MenuItem>
            </Select>
        </>
    )
}

const mapDispatchToProps = {
    filterChange : filterChange
};

export default connect(null, mapDispatchToProps)(TimelineSelect);